<template>
  <span
    v-if="redacted"
    v-tooltip="I18n.t('account_entries_modal.redacted_value_tooltip')"
    class="tw-whitespace-nowrap tw-text-sf-danger-dark-1"
  >
    <i class="fa fa-exclamation-triangle"></i>
    {{ I18n.t('account_entries_modal.redacted_value') }}
  </span>
  <component
    :is="componentType"
    v-else
    :href="url ? url : undefined"
    :target="url ? '_blank' : undefined"
    :class="componentClass"
    class="tw-text-sm tw-leading-[1.4] tw-text-right tw-inline-block tw-w-full"
  >
    <span>{{ amount }}</span>
  </component>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import { computed } from 'vue'

interface Props {
  amount: string
  bold?: boolean
  url: string | null
  redacted?: boolean
}

const { amount = '', bold, redacted, url } = defineProps<Props>()

const I18n = useI18n()

const componentType = computed(() => {
  return url ? 'a' : 'span'
})

const componentClass = computed(() => {
  return {
    'sf-a sf-c-primary-dark': !!url,
    'tw-text-sf-text-dark': !url,
    'tw-font-medium': bold,
  }
})
</script>
